/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@repo/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"fK7YOw":["Downloads"],"qnPNJV":["With our iOS and Android apps, you can learn anything on just-about any device! They’re all 100% free, with no in-app purchases or subscriptions."],"bFN8L2":["Khan Academy"],"jAzJt3":["Download videos for offline viewing, try our massive library of interactive exercises, bookmark things to study later, and complete assignments from your classes! Your progress stays in-sync with your Khan Academy account."],"R+K4Ko":["Screenshots of our iOS and Android apps"],"nm/+B4":["Free for all learners."],"xzQG+s":["Khan Academy is a non-profit, with a mission to provide a world-class education for any learner, anywhere."],"x+4B/p":["Master thousands of skills."],"HEzhZ5":["Our mastery system, featuring thousands of interactive exercises, is easy to use in the app."],"A+Rqhz":["Keep going, keep growing."],"BxO5tD":["Your progress in the app is kept in-sync with your progress on our website!"],"OZHhbA":["Keep learning, even offline."],"Vb0ZAt":["Download any video from our library, so you can watch it even when you don’t have an internet connection."],"40tYEc":["Keep up with your classes."],"BkQOYw":["If you’re enrolled in a class on Khan Academy, you'll see your assignments, course-mastery goals, and more."],"ZbHFJw":["No paper? No problem."],"sGir8L":["Our interactive exercises have a lightweight scratchpad to help you doodle your way through."],"F+nHs4":["Khan Kids"],"AGgRlY":["Inspire a lifetime of learning and discovery with our free, fun educational program for children ages two to eight."],"zwWKhA":["Learn more"],"ah9INv":["Characters from the Khan Kids app"],"bgoC9K":["Third-party Apps"],"ecWenh":["If you need to use Khan Academy in an environment without internet, consider using <0>Kolibri</0>, an ed-tech platform created by <1>Learning Equality</1> that allows for Khan Academy videos and exercises to be used offline."],"5oKEE0":["Kolibri's logo"],"NvMGHQ":["Spreadsheets"],"j8DOm5":["These example spreadsheets are mentioned in some Khan Academy videos. Download and work with them while watching."],"g8t6hn":["Fixed Mortage Calculator"],"5CL99e":["Introduction to the Normal Distribution"],"IJJPAf":["Binomial and Normal Distribution Comparison"],"gErmaC":["Sal's Cupcake Factory"],"VwRXsh":["Home Purchase Model"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["zh-hant","sk","sgn-us","lol","is","fv","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["es","zh-hans","vi","ur","uk","tr","sr","ro","pt","pl","pa","or","nb","ko","km","ka","hy","hi","fr","de","bn","bg","uz","ta","sv","rw","ru","pt-pt","nl","my","mr","mn","lv","lt","ky","kn","kk","ja","it","id","hu","gu","el","da","cs","as","az","te","ar"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
